'use strict';
import {epicsModule} from './epics';
import {TimerExportService} from './services/TimerExportService';

const angular = require('angular');

module.exports = angular
  .module('app.timers', [
    epicsModule.name,
  ])
  .service('timerExportService', TimerExportService)
;



// WEBPACK FOOTER //
// ./src/js/timers/index.js